import { swipers } from './swiper';

/**
 * Toggle the active class on the hamburger
 * Set navigation and navigationActive strings to your used classes
 */
export const initNavigation = function() {
  let hamburger = $('.full-menu-toggle');
  hamburger.on('click', () => {
    hamburger.toggleClass('full-menu-toggle--active');
    $('.full-page-nav').toggleClass('full-page-nav--active');
    $('body').toggleClass('no-scroll');

    setTimeout(() => {
      swipers.update(true);
    }, 100);
  });
};